// extracted by mini-css-extract-plugin
export default {"hiddenInput":"RadioInput_hiddenInput__7JYHg","label":"RadioInput_label__TzngD","holder":"RadioInput_holder__Gbs61"};